import { render, staticRenderFns } from "./OfferFilters.vue?vue&type=template&id=5dc648e4&"
import script from "./OfferFilters.vue?vue&type=script&lang=js&"
export * from "./OfferFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports